module.exports = __webpack_public_path__ + "img/amin-pro.d82f0cb2.jpg";